import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveAuthenticatedLandingTarget } from "@/lib/auth-landing";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: "/login" });
    }

    const target = await resolveAuthenticatedLandingTarget(
      context.auth.user?.preferred_display_board ?? null,
    );

    throw redirect(target);
  },
  component: () => null,
});
